import { call, select } from 'redux-saga/effects';
import { User, UserId } from 'features/users/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import { selectLocalUserId, selectUserById } from 'features/users/usersSlice';
import { logger } from 'utils/logger';
import { signalingPresentContentDisallowed } from 'features/permissions/actions';
import { reconcilePresentContentLibraryPermissionsSaga } from 'features/permissions/sagas/reconcilePresentContentLibraryPermissionsSaga';

export function* onPresentContentDisallowedSaga({
  payload,
}: ReturnType<typeof signalingPresentContentDisallowed>) {
  const { data, initiator } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);

  for (const id of data.users) {
    if (localUserId === id) {
      logger
        .remote({ tier: 1 })
        .info(`The user was disallowed to present content by user id=${initiator.id}`);

      const initiatorUser: User | undefined = yield select(selectUserById, initiator.id);

      if (initiatorUser?.name) {
        yield call(
          notification,
          i18n.t('notifications:present_content_disallowed', { username: initiatorUser.name })
        );
      } else {
        yield call(notification, i18n.t('notifications:present_content_disallowed_unnamed'));
      }

      yield call(reconcilePresentContentLibraryPermissionsSaga);
    }
  }
}
